import styles from './ListThumbnail.module.css';
import classNames from 'classnames/bind';
import Image from 'next/image';
import EmptyNiNimoImage from 'public/images/empty-image-ninimo.jpg';

const cx = classNames.bind(styles);

interface IListThumbnail {
  url?: string;
}
function ListThumbnail({ url }: IListThumbnail) {
  return (
    <>
      {!!url ? (
        <Image
          layout="fill"
          src={url}
          alt="list image"
          className={cx('thumbnail')}
          unoptimized
        />
      ) : (
        <div className={cx('empty-image-card')}>
          <Image
            layout="fill"
            src={EmptyNiNimoImage}
            alt="empty image"
            className={cx('thumbnail')}
            unoptimized
          />
          <span className={cx('description')}>이미지 준비 중입니다...</span>
        </div>
      )}
    </>
  );
}

export default ListThumbnail;
